import type { UIStringsOverride } from "../i18n-ui.ts";

/** Indonesian (id) UI strings. */
export const id: UIStringsOverride = {
  actions: {
    addToCursor: "Tambahkan ke Cursor",
    addToVscode: "Tambahkan ke VS Code",
    askAI: "Tanya AI tentang halaman ini",
    connectMcp: "Hubungkan ke MCP",
    copied: "Disalin!",
    copyClaudeCode: "Salin perintah Claude Code",
    copyCode: "Salin kode",
    copyCodex: "Salin perintah Codex",
    copyMarkdown: "Salin sebagai Markdown",
    copyServerUrl: "Salin URL server",
    edit: "Edit di GitHub",
    export: "Ekspor",
    exportEpub: "Ekspor ke EPUB",
    exportPdf: "Ekspor ke PDF",
    generating: "Menghasilkan…",
    openIn: "Buka di {name}",
    openInChat: "Buka di obrolan",
    scrollToTop: "Kembali ke atas",
  },
  ask: {
    ai: "AI",
    clear: "Hapus percakapan",
    close: "Tutup",
    copy: "Salin percakapan",
    empty: "Ajukan pertanyaan tentang dokumentasi.",
    error: "Maaf, terjadi kesalahan.",
    label: "Ajukan pertanyaan",
    placeholder: "Ajukan pertanyaan…",
    send: "Kirim",
    tip: "Tips: Anda dapat membuka dan menutup obrolan dengan",
    title: "Tanya AI",
    you: "Anda",
  },
  banner: { dismiss: "Tutup pengumuman" },
  changelog: {
    description: "Pembaruan produk dan catatan rilis.",
    showReleases: "Tampilkan rilis {version}",
    title: "Log perubahan",
  },
  content: { diagramError: "Tidak dapat menampilkan diagram ini." },
  feedback: {
    no: "Tidak",
    question: "Apakah halaman ini membantu?",
    thanks: "Terima kasih atas masukan Anda!",
    yes: "Ya",
  },
  languageSwitcher: { label: "Bahasa", untranslated: "Belum diterjemahkan" },
  nav: {
    back: "Kembali",
    breadcrumb: "Remah roti",
    closeNavigation: "Tutup navigasi",
    deprecated: "usang",
    featured: "Unggulan",
    githubRepository: "Repositori GitHub",
    navigation: "Navigasi",
    primary: "Utama",
    sections: "Bagian",
    toggleNavigation: "Buka/tutup navigasi",
    toggleTheme: "Ganti tema warna",
  },
  notFound: {
    description: "Kami tidak dapat menemukan halaman yang Anda cari.",
    home: "Kembali ke beranda",
    title: "Halaman tidak ditemukan",
  },
  page: {
    lastUpdated: "Terakhir diperbarui",
    next: "Berikutnya",
    pagination: "Penomoran halaman",
    previous: "Sebelumnya",
    skipToContent: "Lewati ke konten",
  },
  search: {
    all: "Semua",
    allLanguages: "Semua bahasa",
    askAi: "Tanya AI",
    askAiHint: "Dapatkan jawaban instan dari AI",
    button: "Cari",
    devOnly: "Pencarian tersedia di build produksi.",
    error: "Terjadi kesalahan. Silakan coba lagi.",
    label: "Cari dokumentasi",
    navigate: "navigasi",
    noResults: "Tidak ada hasil ditemukan.",
    open: "buka",
    placeholder: "Cari dokumentasi…",
    popular: "Populer",
    preview: "pratinjau",
    results: "Hasil",
  },
  toc: { title: "Di halaman ini" },
};
